import React from 'react'
import { NavLink, useParams } from 'react-router-dom'

import { ISideBar } from '@/types'
import { t } from '@/i18n'

import {
  carsPath,
  dealsPath,
  driversPath,
  reportsPath,
  invoicesPath,
  proposalPath,
  mainInformationPath,
} from '@/utils'

import Button from './Button'

const sidebarItems: ISideBar[] = [
  {
    requiredCustomer: true,
    path: mainInformationPath,
    icon: 'icon-information',
    label: 'main_information',
  },
  {
    path: carsPath,
    icon: 'icon-car',
    label: 'cars',
  },
  {
    path: dealsPath,
    label: 'deals',
    icon: 'icon-incandescent',
  },
  {
    path: reportsPath,
    label: 'reports',
    icon: 'icon-reports',
  },
  {
    path: driversPath,
    label: 'drivers',
    icon: 'icon-drivers',
  },
  {
    path: invoicesPath,
    label: 'invoices',
    icon: 'icon-file',
  },
  {
    path: proposalPath,
    label: 'proposal',
    icon: 'icon-proposal',
  },
]

const AppSidebar: React.FC = () => {
  const { customerId } = useParams()

  return (
    <div className="side-navigation">
      <div className="navigation-box">
        <div className="menu-btn">
          <Button onClick={() => undefined}>
            <span className="icon-menu"></span>
            {t('menu')}
          </Button>
        </div>
        <div className="menu-item">
          <div className="close-menu">
            <Button onClick={() => undefined}>
              <span className="icon-close"></span>
            </Button>
          </div>
          <div className="scroll-wrap">
            <ul>
              {sidebarItems.map(item => {
                if (item.requiredCustomer && customerId === 'customer') {
                  return null
                }
                return (
                  <li key={item.icon}>
                    <NavLink to={item.path}>
                      <span className={item.icon}></span>
                      {t(item.label)}
                    </NavLink>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AppSidebar
